import { withBase } from "./base";
import { fetchWithRetry } from "./fetch-retry";
import type { QuranChapter, QuranChapterSummary } from "../types";

export async function loadChapterIndex(signal?: AbortSignal): Promise<QuranChapterSummary[]> {
  const response = await fetchWithRetry(withBase("/quran/en/index.json"), { signal });
  if (!response.ok) throw new Error("The Quran index could not be loaded.");
  return response.json() as Promise<QuranChapterSummary[]>;
}

export async function loadChapter(id: number, language: "en" | "ur", signal?: AbortSignal): Promise<QuranChapter> {
  if (!Number.isInteger(id) || id < 1 || id > 114) throw new Error("Invalid surah number.");
  const response = await fetchWithRetry(withBase(`/quran/${language}/${id}.json`), { signal });
  if (!response.ok) throw new Error("This surah could not be loaded.");
  return response.json() as Promise<QuranChapter>;
}

export function globalAyahNumber(chapters: Pick<QuranChapterSummary, "id" | "total_verses">[], surah: number, ayah: number) {
  if (surah < 1 || ayah < 1) throw new Error("Surah and ayah numbers begin at one.");
  return chapters.filter((chapter) => chapter.id < surah).reduce((total, chapter) => total + chapter.total_verses, 0) + ayah;
}

export function audioUrl(globalAyah: number, bitrate: 64 | 128 = 128) {
  return `https://cdn.islamic.network/quran/audio/${bitrate}/ar.alafasy/${globalAyah}.mp3`;
}

export function ayahKey(surah: number, ayah: number) {
  return `${surah}:${ayah}`;
}
